"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertKeyToLanguage = convertKeyToLanguage;
exports.convertLanguageToKey = convertLanguageToKey;
const keyToLanguage = {
    en: 'English UK',
    fr: 'French',
    de: 'German',
    es: 'Spanish',
    it: 'Italian',
    pl: 'Polish',
    pt: 'Portuguese',
    ru: 'Russian',
};
const languageToKey = {
    'English UK': 'en',
    French: 'fr',
    German: 'de',
    Spanish: 'es',
    Italian: 'it',
    Polish: 'pl',
    Portuguese: 'pt',
    Russian: 'ru',
};
function convertKeyToLanguage(key) {
    return keyToLanguage[key];
}
function convertLanguageToKey(language) {
    return languageToKey[language];
}
